/**
 * @fileoverview PUT handler for the "/companies/:company_id/developers/:developer_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdDevelopersDeveloperIdCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdDevelopersDeveloperIdProps,
  CompaniesCompanyIdDevelopersDeveloperIdMutationResult,
} from "./types";

export const putCompaniesCompanyIdDevelopersDeveloperId = reactQueryMutationAdapter(
  companiesCompanyIdDevelopersDeveloperIdCacheKeys,
  (
    props: PutCompaniesCompanyIdDevelopersDeveloperIdProps
  ): Promise<CompaniesCompanyIdDevelopersDeveloperIdMutationResult> => {
    // manipulate props here as needed body

    return fetch(`/companies/${props.companyId}/developers/${props.developerId}`, "PUT", props.body);
  }
);
